//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { AbstractRoomNavModel, AbstractRoomModel } from "@app/catalog-common";

import { 
  debouncedSignal, 
  PresenterRegistration, 
  SignalWrapper 
} from "@app/shared";


@PresenterRegistration({
  types: [AbstractRoomNavModel],
  key: "subMenu",
})
@Component({
  selector: "rooms-submenu",
  standalone: false,
  templateUrl: "./rooms-submenu.component.html",
  styleUrl: "./rooms-submenu.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomsSubmenuComponent<TRoom extends AbstractRoomModel> {
  public data: WritableSignal<AbstractRoomNavModel<TRoom>> = signal<AbstractRoomNavModel<TRoom>>(null);

  /**
   * @summary Filter for items
   * @description: Creates a debounce signal to ensure reduction of filtering
   */
  public roomsFilter = SignalWrapper.create({
    coreSignal: signal<string>(null), 
    overrideSignalFn: (coreSignal) => debouncedSignal(coreSignal, 600)
  });
  
  /**
   * @summary Gets rooms, if a search is applied, the result is filtered by the criteria   
   */
  public filteredRooms = computed(() => {
    let rooms = this.data()?.items();
    if (!rooms) return [];

    let searchValue = this.roomsFilter.overrideSignal();
    if (!searchValue) return rooms; 
    
    return rooms.filter(r => r.value?.fullName()?.toLowerCase().includes(searchValue.toLowerCase()));
  });   
}
